<template>
  <div class="cloudSpace">
    <!-- 云空间基本信息 -->
    <cloudSpatialInfo :user="user" ref="cloudSpatialInfo" />
    <!-- 文件信息编辑 -->
    <file-edit :fileType.sync="fileType" :fileView.sync="fileView" :fromList="fromList" @filesChange="filesChange"
      @fileDownload="fileDownload" />
    <!-- 文件信息列表 -->
    <div class="fromList" @scroll="infiniteScroll" v-show="!getnoContent">
      <component :is="getComponents" :fromList.sync="fromList" @fileChange="fileChange" @handleDel="handleDel"
        @handleReload="handleReload" @fileDownload="fileDownload" @openViewInfo="openViewInfo"
        @importModel="importModel" @pushUserMd5="pushUserMd5" @cancelDownload="cancelDownload" />
    </div>
    <!-- loading -->
    <div class="loading" v-show="loading">
      <img src="@/assets/imgs/cloudSpace/loading.gif" alt="" />
    </div>
    <!-- 暂无数据 -->
    <div class="noContent" v-show="getnoContent">
      <div><img :src="getImg" alt="" /></div>
      {{ $t("no_content") }}
    </div>
    <!-- 查看详情弹框 -->
    <cloudSpatialInfoDialog @importModel="importModel" @fileDownload="fileDownload" @fileChange="fileChange"
      :item="infoItem" :visible.sync="visible" @pushUserMd5="pushUserMd5" />
  </div>
</template>
<script>
import fileEdit from "./components/fileEdit.vue";
import fileList from "./components/fileList.vue";
import fileGrid from "./components/fileGrid.vue";
import cloudSpatialInfo from "./components/cloudSpatialInfo.vue";
import cloudSpatialInfoDialog from "./dialog/cloudSpatialInfoDialog.vue";
import {
  postUserFiles,
  postUserStore,
  getDownloadUrls,
} from "@/api/network/printer";
import {
  existsFile,
  importModel,
  setNotify,
  fileMd5,
  moveFile,
  configWrite,
  configRead,
} from "@/api/slicer/printer";
import { mapState } from "vuex";
export default {
  name: "cloudSpace",
  components: {
    fileEdit,
    fileList,
    fileGrid,
    cloudSpatialInfo,
    cloudSpatialInfoDialog,
  },
  data () {
    return {
      fileView: "list",
      fromList: [],
      //  页码
      page: {
        page: 1,
        page_count: 25,
        total: 0,
      },
      //  用户云空间基础信息
      user: {
        total: "",
        used: "",
        total_bytes: 0,
        used_bytes: 0,
        progress: 0,
      },
      //  文件类型
      fileType: 0,
      //  loading
      loading: false,
      //  模型详情弹框
      infoItem: {},
      //  模型弹框是否显示
      visible: false,
      faild: false,
      //  增加用户信息
      userId: null,
      downloadControllers: {},
    };
  },
  computed: {
    ...mapState({
      fileList: (state) => state.user.fileList,
      downloadFileList: (state) => state.user.downloadFileList,
    }),
    getComponents () {
      return this.fileView == "list" ? "fileList" : "fileGrid";
    },
    getnoContent () {
      return !this.loading && this.fromList.length == 0;
    },
    getImg () {
      return this.$store.state.user?.isDark
        ? require(`@/assets/dark/noContent.webp`)
        : require(`@/assets/imgs/cloudSpace/noContent.webp`);
    },
    getSize () {
      return (sizeBytes) => {
        if (!sizeBytes) return "";
        const units = ["Bytes", "KB", "MB", "GB"];
        let unitIndex = 0;

        while (sizeBytes >= 1024 && unitIndex < units.length - 1) {
          sizeBytes /= 1024;
          unitIndex++;
        }

        return `${sizeBytes.toFixed(2)} ${units[unitIndex]}`;
      };
    },
    getTime () {
      return (timestamp) => {
        if (!timestamp) {
          return "";
        }
        const date = new Date(timestamp * 1000);

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份从0开始
        const day = String(date.getDate()).padStart(2, "0");
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      };
    },
    getImgUrl () {
      return (val) => {
        if (val) {
          return val;
        } else {
          return require(`@/assets/imgs/cloudSpace/default-image.webp`);
        }
      };
    },
  },
  watch: {
    fileType: {
      async handler (val) {
        this.loading = true;
        this.fromList = [];
        await this.getUserFilesList();
        this.loading = false;
      },
    },
    //  上传文件列表
    fileList: {
      async handler (newVal, oldVal) {
        if (newVal.length) {
          this.uploadList(newVal);
        } else if (oldVal?.length > 0 && newVal.length == 0) {
          // if (oldVal?.every(item => item.percent == 100)) {
          this.page.page = 1;
          this.loading = true;
          this.fromList = [];
          await this.getUserFilesList();
          await this.getUserStore();
          this.loading = false;
          // }
          await configWrite("TransferUploadStatus", 0);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  async activated () {
    // 当第一次进入/用户切换重新请求服务
    const id = this.$store.state.user?.uploadCenter_user_info?.casdoor_user_id;
    if (!id) return;
    if (!this.userId || this.userId != id) {
      // this.$store.commit('SET_USER_DOWNLOAD_LIST', [])
      this.fromList = [];
      this.loading = true;
      await this.getUserFilesList();
      await this.getUserStore();
      this.loading = false;
      setNotify(this.callBack);
    }
  },
  mounted () {
    // 监听网络离线事件
    window.addEventListener("offline", this.offline);
    // if ('connection' in navigator) {
    //   navigator.connection.addEventListener('change', this.offline);
    // }
  },
  beforeDestroy () {
    // 监听网络离线事件
    window.removeEventListener("offline", this.offline);
    // if ('connection' in navigator) {
    //   navigator.connection.removeEventListener('change', this.offline);
    // }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.$store.getters["GET_TOKEN"]) {
      //  退出登录，删除用户数据
      configWrite("TransferDownloadStatus", 0);
      configWrite("TransferUploadStatus", 0);
      this.fileList.map((item) => {
        this.$refs.cloudSpatialInfo.unlockStorageSpace(
          item.user_lock_space_id,
          0
        );
      });
      this.$store.commit("SET_FILE_LIST", []);
    }
    next();
  },
  methods: {
    //  模型下载失败(用户自主取消不用提示下载失败)
    async downloadError (id, val = 'default') {
      if (val === 'error') {
        this.$message.error(this.$t("download_failure"));
        this.setListState(id, {
          fileStateStr: 'default'
        })
      }
      await this.downloadCancel(id)
      await this.calcDownloadFileList();
    },
    //  取消当前下载记录
    async downloadCancel (id) {
      const controller = this.downloadControllers[id];
      if (controller) {
        controller?.abort();
        await configWrite("TransferDownloadStatus", 0);
      }
      const list = this.downloadFileList;
      const index = list.findIndex((item) => item.id == id);
      if (index !== -1) {
        list.splice(index, 1);
        this.$store.commit("SET_DOWNLOAD_FILE_LIST", list);
      }
    },
    //  更新当前列表的状态
    setListState (id, arg) {
      const index = this.fromList.findIndex((item) => id == item.id);
      if (index === -1) return;
      this.$set(
        this.fromList,
        index,
        Object.assign(this.fromList[index], {
          ...arg
        })
      );
    },
    //  判断是否开启新的下载任务
    async calcDownloadFileList () {
      //  查询当前下载列表，还有数据就再次开始下载新数据
      if (this.downloadFileList.length > 0) {
        const { downloadUrl, id, filename } = this.downloadFileList[0]
        const controller = this.downloadControllers[id];
        if (controller) return
        this.download(downloadUrl, id, filename)
        await configWrite("TransferDownloadStatus", 1);
      } else {
        await configWrite("TransferDownloadStatus", 0);
      }
    },
    //  删除下载记录
    async delDownloadList () {
      this.$message.error(this.$t("download_failure"));
      //  清空当前下载任务
      for (let key in this.downloadFileList) {
        if (key) {
          this.downloadCancel(key)
        }
      }
      this.downloadFileList.forEach(item => {
        this.setListState(item.id, {
          fileStateStr: 'default'
        })
      })
      
      this.$store.commit("SET_USER_DOWNLOAD_LIST", []);
      await configWrite("TransferDownloadStatus", 0);
    },
    //  设备离线，有正在上传或下载的文件需要提示
    //  正在上传/下载文件需要停止
    async offline () {
      const downloadList = this.downloadFileList;
      const fileList = this.$store.state.user?.fileList;
      if (downloadList.length && fileList.length) {
        this.delDownloadList();
      } else if (!downloadList.length && fileList.length) {
        this.$message.error(this.$t("upload_failed"));
      } else if (downloadList.length && !fileList.length) {
        this.delDownloadList();
      }
      await configWrite("TransferUploadStatus", 0);
    },
    //  维护用户下载文件的md5值
    async pushUserMd5 (str, newKey = "", oldKey = "", value = "") {
      const list = this.$store.state.printer.userDownloadList;
      const userId = this.$store.state.user.uploadCenter_user_info.id;
      const index = list.findIndex((item) => item.id == userId);

      switch (str) {
        case "add":
          if (index != -1) {
            list[index][newKey] = value;
          } else {
            list.push({ id: userId });
            list[list.length - 1][newKey] = value;
          }

          break;
        case "update":
          // list[index][newKey] = list[index][oldKey];
          // delete list[index][oldKey];
          moveFile(newKey, oldKey);
          break;
        case "del":
          break;
      }
      this.$store.commit("SET_USER_DOWNLOAD_LIST", list);
    },
    //  二次判断云空间文件与本地文件是否一致
    // async getUniqueFile (str) {
    //   // await this.$store.dispatch('GET_USER_DOWNLOAD_LIST')
    //   const list = this.$store.state.printer.userDownloadList;
    //   const userId = this.$store.state.user.uploadCenter_user_info.id;
    //   const index = list.findIndex((item) => item.id == userId);
    //   const md5 = await fileMd5(str, 0);
    //   const faild = index != -1 ? list[index][str] == md5 : false;

    //   return faild;
    // },
    //  下载文件返回的消息回调
    async callBack (url, orgin_md5, fast_md5) {
      // //  处理字段
      // const obj = {};
      // const key = orgin_md5.split("\\")[orgin_md5.split("\\").length - 1];
      // obj[key] = fast_md5;

      // this.pushUserMd5("add", key, "", fast_md5);
      setTimeout(() => {
        this.calcDownloadFileList();
      },1000)
    },
    //  单文件导入
    async importModel (val) {
      // const faild = await this.getUniqueFile(val.old_filename);
      // if (faild) {
      const isDownloadPramas = await existsFile(val.old_filename);
      if (isDownloadPramas == 1) {
        importModel(val.old_filename, 0);
      } else {
        importModel(`${val.fileNameStr} (1).${file_extension}`, 0);
      }

      // } else {
      //   this.$message.error(this.$t("file_not_exist"));
      //   setTimeout(() => {
      //     location.reload();
      //   }, 1000);
      // }
    },
    //  打开详情
    async openViewInfo (obj) {
      this.infoItem = obj;
      this.visible = true;
    },
    //  判断文件是被下载
    async getExistsFile (arr) {
      const promiseAll = [];
      arr.forEach((item) => {
        promiseAll.push(existsFile(item));
      });
      const all = await Promise.all(promiseAll);
      return all;
    },
    //  文件下载
    async fileDownload (arr) {
      const ids = arr.map((item) => {
        item.fileStateStr = "download";
        return item.id;
      });
      const res = await getDownloadUrls({
        ids,
      });
      if (res.code == 1) {
        //  批量下载改成顺序下载
        let list = arr.map((item, index) => {
          const fildIndex = arr.findIndex(fildItem => fildItem.id == item.id)
          return {
            id: item.id,
            fileStateStr: "download",
            downloadPercent: 0,
            downloadUrl: arr[fildIndex].url,
            filename: item.old_filename
          }
        })
        if (list.length === 0) return
        this.download(list[0].downloadUrl, list[0].id, list[0].filename)
        await configWrite("TransferDownloadStatus", 1);
        this.$store.commit("SET_DOWNLOAD_FILE_LIST", list);
      } else {
        arr.map((item) => {
          item.fileStateStr = "default";
          return item;
        });
      }
    },
    //  下载逻辑封装
    async download (downloadUrl, id, filename) {
      const controller = new AbortController();
      const { signal } = controller;
      let fromListIndex = this.fromList.findIndex(item => id == item.id)

      // 保存controller，以便后续取消某个文件下载
      this.downloadControllers[id] = controller;

      const url = downloadUrl;

      // 获取已下载的字节数
      let loaded = 0;

      try {
        const response = await fetch(url, { signal });

        if (!response.ok && response.status !== 206) {
          console.error("网络错误:", response.statusText);
          this.downloadError(id,'error');
          return;
        }

        const contentLength = response.headers.get("Content-Length");
        const total = parseInt(contentLength, 10); // 更新总大小
        const reader = response.body.getReader();
        const chunks = [];

        const faild = true;
        while (faild) {
          const { done, value } = await reader.read();
          if (done) {
            //  更新列表，并删除下载列表该条数据
            this.setListState(id, {
              fileStateStr: 'import'
            });
            this.downloadCancel(id);
            await configWrite("TransferDownloadStatus", 0);
            break;
          }

          chunks.push(value);
          loaded += value.length;
          const percent = (loaded / total) * 100;

          //  添加下载中数据
          const list = this.downloadFileList;
          const fileListIndex = list.findIndex((item) => id == item.id);
          if (fileListIndex !== -1) {
            // list[fileListIndex].downloadPercent = percent.toFixed(2);
            this.$set(
              this.fromList,
              fromListIndex,
              Object.assign(this.fromList[fromListIndex], {
                downloadPercent: percent.toFixed(2),
              })
            );
          }
          // console.log(`下载进度: ${percent.toFixed(2)}%`);
          console.log(`下载进度: ${percent.toFixed(2)}%`, id, filename, this.downloadControllers,this.downloadFileList);

          // 判断是否中止下载
          if (signal.aborted) {
            this.downloadError(id);
            throw new Error("下载被取消");
          }
        }

        // 创建 Blob 和下载链接的逻辑
        await configWrite("TransferDownloadStatus", 0);
        const blob = new Blob(chunks);
        const urlBlob = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = urlBlob;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(urlBlob);
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error("下载过程中发生错误:", error);
          this.downloadError(id, 'error')
        } else {
          this.downloadError(id)
        }
      } finally {
        // 下载完成或被取消后，清理controller
        this.downloadCancel(id)
      }
    },
    async cancelDownload (id) {
      //  判断当前数据是否被下载
      await this.downloadError(id);
    },
    //  重新上传
    handleReload (obj) {
      this.$refs.cloudSpatialInfo.handleReload(obj);
    },
    //  取消上传
    handleDel (obj) {
      //  获取上传列表的数据进行取消上传逻辑
      const fileIndex = this.fileList.findIndex(
        (item) => item.user_lock_space_id == obj.user_lock_space_id
      );
      if (fileIndex != -1) {
        this.$refs.cloudSpatialInfo.handleDel(this.fileList[fileIndex]);
      }
      let index = this.fromList.findIndex(
        (item) => item.user_lock_space_id == obj.user_lock_space_id
      );
      this.fromList.splice(index, 1);
    },
    //  更新上传中的文件
    uploadList (files) {
      files.forEach((item, filesIndex) => {
        const { fileName, fileType } = this.splitFileName(item.name);
        item.old_filename = fileName;
        item.file_extension = fileType;
        item.sizeStr = this.getSize(item.size);
        item.thumbnailStr = require(`@/assets/imgs/cloudSpace/default-image.webp`);
        if (item.percent == 100 && filesIndex != files.length - 1) {
          item.timeStr = new Date().toLocaleString().split("/").join("-");
          item.percentage = 1;
        }
        let faild = false;

        //  当上传类型与当前选择的类型不同时，不插入列表
        switch (this.fileType) {
          case 0:
            faild = true;
            break;
          case 1:
            faild = fileType.toLowerCase() == "3mf";
            break;
          case 2:
            faild = fileType.toLowerCase() == "gcode";
            break;
          case 3:
            faild =
              fileType.toLowerCase() == "stl" ||
              fileType.toLowerCase() == "obj";
            break;
          case 4:
            faild =
              fileType.toLowerCase() != "3mf" &&
              fileType.toLowerCase() != "gcode" &&
              fileType.toLowerCase() != "stl" &&
              fileType.toLowerCase() != "obj";
        }
        if (!faild) return;

        const index = this.fromList.findIndex(
          (listItem) => listItem.user_lock_space_id == item.user_lock_space_id
        );
        if (index == -1) {
          // this.$set(item, 'percent', item.percent)
          this.fromList.unshift(item);
          this.$set(this.fromList[0], "percent", Number(item.percent));
        } else {
          this.fromList.splice(index, 1, item);
          this.$set(this.fromList[index], "percent", Number(item.percent));
        }
      });
    },
    splitFileName (fileName) {
      // 获取文件类型
      const lastDotIndex = fileName.lastIndexOf(".");
      const fileType = fileName.substring(lastDotIndex + 1); // 取最后一个点之后的部分
      const name = fileName.substring(0, lastDotIndex); // 取最后一个点之前的部分

      return {
        fileName: name,
        fileType: fileType,
      };
    },
    //  瀑布流
    async infiniteScroll (ev) {
      const { clientHeight, scrollHeight, scrollTop } = ev.target;
      let height = 0;
      if (
        !(
          clientHeight + scrollTop + 50 > scrollHeight &&
          scrollHeight > clientHeight
        )
      )
        return;
      const { page, page_count, total } = this.page;
      if (
        !(total - page_count * page > 0) ||
        this.fromList.length == 0 ||
        this.loading
      )
        return;
      this.loading = true;
      this.page.page += 1;
      //  解决el-table 插入数据后滚轮一直在底部的问题
      if (this.fileType == 0) {
        height = document.querySelectorAll(".fromList")[0].scrollHeight;
      }
      await this.getUserFilesList();
      if (this.fileType == 0) {
        this.$nextTick(() => {
          const el = document.querySelectorAll(".fromList")[0];
          el.scrollTop > height && (el.scrollTop = height);
          this.loading = false;
        });
      } else {
        this.loading = false;
      }
    },
    //  单文件修改
    async fileChange (str, obj) {
      const index = this.fromList.findIndex((item) => item.id == obj.id);
      if (str == "update") {
        this.$set(this.fromList, index, obj);
        //  当详情页打开，需要同步更新数据
        if (this.visible) {
          obj.fileNameStr = this.splitFileName(obj.old_filename)["fileName"];
          this.infoItem = obj;
        }
      } else {
        this.fromList.splice(index, 1);
        if (this.fromList.length == 0 && total - page_count * page > 0) {
          this.page.page = 1;
          this.loading = true;
          await this.getUserFilesList();
          this.loading = false;
        }
        this.getUserStore();
      }
    },
    //  多文件修改
    async filesChange (str, arr) {
      const { page, page_count, total } = this.page;
      if (str == "update") {
        this.fromList = arr;
      } else {
        arr.forEach((item) => {
          const index = this.fromList.findIndex((idx) => idx.id == item);
          if (index != -1) {
            this.cancelDownload(this.fromList[index].id)
            this.fromList.splice(index, 1);
          }
        });

        if (this.fromList.length == 0 && total - page_count * page > 0) {
          this.page.page = 1;
          this.loading = true;
          await this.getUserFilesList();
          this.loading = false;
        }

        this.getUserStore();
      }
    },
    //  获取用户已经使用的存储空间
    async getUserStore () {
      const res = await postUserStore();
      if (res.code != 1) return;
      const { total_bytes, total, used, used_bytes } = res.data;
      this.user.used = used;
      this.user.total = total;
      this.user.total_bytes = total_bytes;
      this.user.used_bytes = used_bytes;
      this.user.progress = (used_bytes / total_bytes) * 100 || 0;
    },
    //  获取文件列表
    async getUserFilesList () {
      const params = {
        page: this.page.page,
        limit: this.page.page_count,
        file_type: this.fileType,
      };
      const res = await postUserFiles(params);
      if (res.code != 1) return;
      const isDownloadPramas = await this.getExistsFile(
        [...res.data]?.map((item) => item.old_filename)
      );
      this.$nextTick(() => {
        this.fromList.push(
          ...res.data.map((item, index) => {
            //  前端添加字段：
            item.checkbox = false; //  多选是否点击
            item.percent = 0; //  上传进度条
            item.downloadPercent = 0; //  下载进度条
            item.fileStateStr = isDownloadPramas[index] ? "import" : "default"; //  当前文件状态
            item.sizeStr = this.getSize(item.size); //  文件大小
            item.timeStr = this.getTime(item.update_time || item.create_time); //  更新时间
            item.thumbnailStr = this.getImgUrl(item.thumbnail); //  图片预览
            item.fileNameStr = this.splitFileName(item.old_filename)[
              "fileName"
            ]; //  文件名
            return item;
          })
        );
        this.page = res.pageData;
      });
    },
  },
};
</script>
<style scoped lang="scss">
.cloudSpace {
  position: relative;
  background-color: var(--dialog-background-color);
  width: 100%;
  height: 100%;
  padding: 10px 20px 16px 20px;

  .fromList {
    margin-top: 15px;
    max-height: calc(100vh - 205px);
    overflow: auto;
  }

  .noContent {
    margin-top: 15px;
    height: calc(100vh - 205px);
  }

  .files-pagination {
    margin-top: 16px;
    display: flex;
    justify-content: center;
  }

  .noContent {
    color: var(--second-text-color);
    font-size: 15px;
    line-height: 18px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    div {
      margin-top: 12px;
    }
  }

  .loading {
    display: flex;
    align-items: center;
    justify-content: center;
    height: calc(100% - 178px);
    width: calc(100% - 48px);
    position: absolute;
    bottom: 10px;
    background: var(--dialog-background-color);
    z-index: 2000;
  }
}

::v-deep {
  .el-button {
    &--small {
      padding: 0 10px;
    }

    &--default {
      border-color: var(--three-btn-border);
      border-radius: 6px;
    }

    &--default:hover,
    &--default:active {
      border-color: #3986ff;
    }
  }

  .el-button:focus {
    background-color: var(--dialog-background-color);
  }

  .el-progress-bar__outer {
    height: 8px !important;
  }
}
</style>
